import { useAuthStore } from '@/stores/authStore'
import { CNPJ_NEW_DRIVER } from '@/lib/constants'

interface RotuloDeFilho {
  singular: string
  plural: string
  artigoSingular: string
}

/**
 * Os filhos da New Driver são parceiros; os de um parceiro são captadores. Vale o parceiro
 * SELECIONADO, não o papel do usuário: um administrador operando por outro parceiro cadastra
 * captadores como qualquer um.
 */
export function useRotuloDeFilho(): RotuloDeFilho {
  const operandoPelaNewDriver = useAuthStore((s) => s.parceiro?.cpfCnpj === CNPJ_NEW_DRIVER)

  if (operandoPelaNewDriver) {
    return { singular: 'parceiro', plural: 'Parceiros', artigoSingular: 'o parceiro' }
  }
  return { singular: 'captador', plural: 'Captadores', artigoSingular: 'o captador' }
}
